import {HeightAnimation} from './animations/HeightAnimation';

export class TeaserOverlay {

    constructor(private element:JQuery<HTMLElement>) {
        element.on('click',(ev)=>this.click(ev));
    }

    click(ev:JQuery.TriggeredEvent) {
        let target=$(ev.target);
        if (!target.closest('.toggle').length) return;

        let overlay=this.element.find('.overlay');
        this.element.toggleClass('open');

        if (this.element.hasClass('open')) {
            new HeightAnimation(overlay).to('auto').play();
        } else {
            new HeightAnimation(overlay).to(0).play();
        }

    }

}

export {};